import { handleActions } from 'redux-actions';

import * as actions from './actions';
import * as base from "../BaseReducers";

const initialState = Object.assign({},
  base.ListState,
  base.DetailState,
  base.EditState,
);

export default handleActions(
  {
    [actions.geoCityShowEditForm]: (state, action) => base.showEditForm(state, action),

    [actions.geoCityLoadRequest]: (state, action) => base.listLoadRequest(state, action),
    [actions.geoCityLoadComplete]: (state, action) => base.listLoadComplete(state, action),
    [actions.geoCityLoadError]: (state, action) => base.listLoadError(state, action),

    [actions.geoCityDetailLoadRequest]: (state, action) => base.detailLoadRequest(state, action),
    [actions.geoCityDetailLoadComplete]: (state, action) => base.detailLoadComplete(state, action),
    [actions.geoCityDetailLoadError]: (state, action) => base.detailLoadError(state, action),

    [actions.geoCityUpdateRequest]: (state, action) => base.updateRequest(state, action),
    [actions.geoCityUpdateComplete]: (state, action) => base.updateComplete(state, action),
    [actions.geoCityUpdateError]: (state, action) => base.updateError(state, action),

    [actions.geoCityDeleteRequest]: (state, action) => base.deleteRequest(state, action),
    [actions.geoCityDeleteComplete]: (state, action) => base.deleteComplete(state, action),
    [actions.geoCityDeleteError]: (state, action) => base.deleteError(state, action),
  },
  initialState
);
